import axios from '@/extra-functions/axios.extra'
import { errorHandler } from './../extra-functions/store.extra'

const state = {
  list: [],
  graphList: [],
  index: 0,
  dataCount: 0,
  storing: false,
  verifyErrors: [],
  verifying: false,
  channelUpdate: '',
  fetching: false,
  countingData: false,
  updating: false,
  fetchErrors: [],
  countingDataErrors: [],
  updateErrors: [],
  storeErrors: [],
  storeSuccess: false,
  updateSuccess: false,
  stockCountErrors: [],
  stockCount: [],
  stockCounting: false,
  tempList: [],
}

const mutations = {
  SET_LIST (state, payload) {
    state.list = payload
  },
  SET_STOCK_COUNT (state, payload) {
    state.stockCount = payload
  },
  SET_STOCK_COUNT_ERRORS (state, payload) {
    state.stockCount = payload
  },
  SET_GRAPH_LIST (state, payload) {
    state.graphList = payload
  },
  EMPTY_LIST (state, payload) {

  },
  CHANNEL_UPDATED (state, payload) {
    state.channelUpdate = payload
  },
  SET_INDEX (state, payload) {

  },
  SET_DATA_COUNT (state, payload) {
    state.dataCount = payload
  },
  DATA_COUNTING_TRUE (state) {
    state.countingData = true
  },
  DATA_COUNTING_FALSE (state) {
    state.countingData = false
  },
  SET_COUNTING_DATA_ERRORS (state, payload) {
    state.countingDataErrors = payload
  },
  SET_FETCHING_ERRORS (state, payload) {
    state.fetchErrors = payload
  },
  SET_STORING_ERRORS (state, payload) {
    state.storeErrors = payload
  },
  SET_UPDATING_ERRORS (state, payload) {
    state.updateErrors = payload
  },
  UPDATE_SUCCESS_TRUE (state) {
    state.updateSuccess = true
  },
  UPDATE_SUCCESS_FALSE (state) {
    state.updateSuccess = false
  },
  STORE_SUCCESS_TRUE (state) {
    state.storeSuccess = true
  },
  STORE_SUCCESS_FALSE (state) {
    state.storeSuccess = false
  },
  FETCHING_TRUE (state) {
    state.fetching = true
  },
  FETCHING_FALSE (state) {
    state.fetching = false
  },
  UPDATING_TRUE (state) {
    state.updating = true
  },
  UPDATING_FALSE (state) {
    state.updating = false
  },
  STORING_TRUE (state) {
    state.storing = true
  },
  STORING_FALSE (state) {
    state.storing = false
  },
  SET_VERIFY_ERRORS (state, payload) {
    state.verifyErrors = payload
  },
  VERIFYING_TRUE (state) {
    state.verifying = true
  },
  VERIFYING_FALSE (state) {
    state.verifying = false
  },
  SET_STOCK_COUNTING (state, payload = false) {
    state.stockCounting = payload
  },
  ADD_TEMP_ITEM (state, payload) {
    state.tempList.push(payload)
  },
  REMOVE_TEMP_ITEM (state, payload) {
    state.tempList.splice(payload, 1)
  },
  CLEAR_TEMP_LIST (state) {
    state.tempList = []
  },
}

const actions = {
  fetch ({ state, commit, rootState }, { index, count, search, dateStart, dateEnd }) {
    const token = rootState.auth.token
    const ax = axios(token)
    commit('SET_FETCHING_ERRORS', [])
    if (!state.fetching) {
      commit('FETCHING_TRUE')
      ax.get(`lost-inventories/offset/${index}/limit/${count}`, { params: { search, dateStart, dateEnd } })
        .then(({ data }) => {
          commit('SET_LIST', data)
        }).catch(errors => {
          commit('SET_FETCHING_ERRORS', errorHandler(errors))
        }).then(() => commit('FETCHING_FALSE'))
    }
  },
  fetchDataCount ({ state, commit, rootState }, { search, dateStart, dateEnd }) {
    const token = rootState.auth.token
    const ax = axios(token)
    commit('SET_COUNTING_DATA_ERRORS', [])
    if (!state.countingData) {
      commit('DATA_COUNTING_TRUE')
      ax.get('lost-inventories/count', { params: { search, dateStart, dateEnd } })
        .then(({ data }) => {
          commit('SET_DATA_COUNT', data)
        }).catch(errors => {
          commit('SET_COUNTING_DATA_ERRORS', errorHandler(errors))
        }).then(() => commit('DATA_COUNTING_FALSE'))
    }
  },
  countStocks ({ state, commit, rootState }, { date }) {
    const token = rootState.auth.token
    const ax = axios(token)
    commit('SET_STOCK_COUNT_ERRORS', [])
    if (!state.stockCounting) {
      commit('SET_STOCK_COUNTING', true)
      ax.get('')
        .then(({ data }) => {
          commit('SET_STOCK_COUNT', data)
        }).catch(errors => {
          commit('SET_STOCK_COUNT_ERRORS', errorHandler(errors))
        }).then(() => {
          commit('SET_STOCK_COUNTING', false)
        })
    }
  },
  store ({ state, commit, rootState }, data) {
    const token = rootState.auth.token
    const ax = axios(token)
    commit('SET_STORING_ERRORS', [])
    if (!state.storing) {
      commit('STORE_SUCCESS_FALSE')
      commit('STORING_TRUE')
      ax.post('lost-inventories', { data })
        .then(({ data }) => {
          commit('STORE_SUCCESS_TRUE')
        }).catch(errors => {
          commit('SET_STORING_ERRORS', errorHandler(errors))
        }).then(() => {
          commit('STORING_FALSE')
        })
    }
  },
  checkErrors ({ state, commit, rootState }, { data, success, self }) {
    const token = rootState.auth.token
    const ax = axios(token)
    if (!state.verifying) {
      commit('VERIFYING_TRUE')
      commit('SET_VERIFY_ERRORS', [])
      ax.post('lost-inventories/checkErrors', data)
        .then(({ data }) => {
          success(data, self)
        }).catch(errors => {
          commit('SET_VERIFY_ERRORS', errorHandler(errors))
        }).then(() => commit('VERIFYING_FALSE'))
    }
  },
  update ({ state, commit, rootState }, { id, data }) {
    const token = rootState.auth.token
    const ax = axios(token)
    commit('SET_UPDATING_ERRORS', [])
    if (!state.updating) {
      commit('UPDATE_SUCCESS_FALSE')
      commit('UPDATING_TRUE')
      ax.put(`lost-inventories/${id}`, data)
        .then(({ data }) => {
          commit('UPDATE_SUCCESS_TRUE')
        }).catch(errors => {
            commit('SET_UPDATING_ERRORS', errorHandler(errors))
        }).then(() => commit('UPDATING_FALSE'))
    }
  },
  fetchWeekly ({ state, commit, rootState }, { date }) {
    const token = rootState.auth.token
    const ax = axios(token)
    commit('SET_FETCHING_ERRORS', [])
    if (!state.fetching) {
      commit('FETCHING_TRUE')
      ax.get('lost-inventories/summary/weekly', { params: { date } })
        .then(({ data }) => {
          commit('SET_GRAPH_LIST', data)
        }).catch(errors => {
          commit('SET_FETCHING_ERRORS', errorHandler(errors))
        }).then(() => commit('FETCHING_FALSE'))
    }
  },
  fetchMonthly ({ state, commit, rootState }, { date }) {
    const token = rootState.auth.token
    const ax = axios(token)
    commit('SET_FETCHING_ERRORS', [])
    if (!state.fetching) {
      commit('FETCHING_TRUE')
      ax.get('lost-inventories/summary/monthly', { params: { date } })
        .then(({ data }) => {
          commit('SET_GRAPH_LIST', data)
        }).catch(errors => {
          commit('SET_FETCHING_ERRORS', errorHandler(errors))
        }).then(() => commit('FETCHING_FALSE'))
    }
  },
  fetchYearly ({ state, commit, rootState }, { date }) {
    const token = rootState.auth.token
    const ax = axios(token)
    commit('SET_FETCHING_ERRORS', [])
    if (!state.fetching) {
      commit('FETCHING_TRUE')
      ax.get('lost-inventories/summary/yearly', { params: { date } })
        .then(({ data }) => {
          commit('SET_GRAPH_LIST', data)
        }).catch(errors => {
          commit('SET_FETCHING_ERRORS', errorHandler(errors))
        }).then(() => commit('FETCHING_FALSE'))
    }
  },
  channelUpdated ({ state, commit }) {
    commit('CHANNEL_UPDATED', new Date().getTime())
  },
  addTempItem ({ commit }, payload) {
    commit('ADD_TEMP_ITEM', payload)
  },
  clearTempList ({ commit }) {
    commit('CLEAR_TEMP_LIST')
  },
  removeTempItem ({ commit }, payload) {
    commit('REMOVE_TEMP_ITEM', payload)
  },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    strict: true,
}
